import { render, staticRenderFns } from "./AnnotationsContainer.vue?vue&type=template&id=49cbbd91&scoped=true&"
import script from "./AnnotationsContainer.vue?vue&type=script&lang=js&"
export * from "./AnnotationsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cbbd91",
  null
  
)

export default component.exports